import styles from "./Footer.module.css";
import SocailIcons from "../SocailIcons/SocailIcons";
import ContactNumbers from "../ContactNumbers/ContactNumbers";
import Line from "../Line/Line";
import logo from '../../images/logo.png'
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer>
      <Line />
      <div className={styles.footer__container}>
        {/* <Container> */}
        <div className={styles.text_wrapper}>

          <Link to="/">
            <img src={logo} alt="logo" className={styles.footerIcon} />
          </Link>
          <p className={styles.title}>Електромонтажні роботи в Києві</p>
          <p className={styles.subTitle}>Якісно, Швидко, Доступно</p>
        </div>

        <ContactNumbers />
        {/* <ul className={styles.contacts__list}>
          <li className={styles.contacts__item}>
            <a className={styles.contacts__link} href="tel:+380962152544">
              +38 (096) 215-25-44
            </a>
          </li>
          <li className={styles.contacts__item}>
            <a className={styles.contacts__link} href="tel:+380962152544">
              +38 (096) 215-25-44
            </a>
          </li>
        </ul> */}
        <SocailIcons />
        {/* </Container> */}
      </div>
      <div className={styles.rights}>
        <p className={styles.rights__text}>
          © 2022 Нові електричні мережі
        </p>
      </div>
    </footer>
  );
};

export default Footer;
